import styled from 'styled-components';
import { FAMILY_FONT_CONTROL, TITLE_SIZE_4 } from '../../const/text';
import { SECONDARY_COLOR, SECONDARY_COLOR_1 } from '../../const/color';
import Icon from '../Global/Icon';
import { device } from '../../const/device';

export const Header = styled.div`
  display: flex;
  flex-direction: row;
  height: 36px;
  align-items: center;
  margin-bottom: 28px;
`;



export const IconContainer = styled.div`
  margin-left: auto;
  > button {
    margin-left: 16px;
  }
`;
export const TitleContainer = styled.div<{ themeColor: string }>`
  font-size: ${TITLE_SIZE_4}px;
  line-height: 130%;
  color: ${ props => props.themeColor == "black"?'#ffffff':SECONDARY_COLOR};
  letter-spacing: 0.005em;
  text-transform: uppercase;
`;

export const Block = styled.div<{ themeColor: string }>`
  font-family: ${FAMILY_FONT_CONTROL};
  font-size: 16px;
  line-height: 26px;
  color: ${props => props.themeColor == "black"?'#bebebe':SECONDARY_COLOR_1};;
  margin-bottom: 38px;
  
  ${Icon} {
    margin-right: 9px;  
  }
`;

export const BlockTitle = styled.div<{ themeColor: string }>`
  font-weight: bold;
  letter-spacing: 0.02em;
  color: ${props => props.themeColor == "black"?'#ffffff':SECONDARY_COLOR};
  margin-bottom: 6px;
`;